import { render, staticRenderFns } from "./popCategorySearch.vue?vue&type=template&id=243db5fc&scoped=true&"
import script from "./popCategorySearch.vue?vue&type=script&lang=js&"
export * from "./popCategorySearch.vue?vue&type=script&lang=js&"
import style0 from "./popCategorySearch.vue?vue&type=style&index=0&id=243db5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243db5fc",
  null
  
)

export default component.exports